// Small form primitives for the set-up screens.

import type { ComponentChildren } from 'preact';
import { useState } from 'preact/hooks';

export const inputCls = 'h-9 rounded-lg border border-[var(--color-border)] bg-[var(--color-bg)] px-2.5 text-[13.5px] text-[var(--color-text)] min-w-0';

export function Field({ label, error, children, class: cls }: { label: string; error?: string; children: ComponentChildren; class?: string }) {
  return (
    <label class={'flex flex-col gap-1 text-[12px] text-[var(--color-text-muted)] ' + (cls ?? '')}>
      {label}
      {children}
      {error && <span class="text-[11.5px] text-[#b42318]">{error}</span>}
    </label>
  );
}

export function Btn({ kind = 'plain', children, ...rest }: {
  kind?: 'primary' | 'plain' | 'danger'; type?: 'button' | 'submit'; disabled?: boolean;
  onClick?: () => unknown; class?: string; title?: string; children: ComponentChildren;
}) {
  const base = 'h-9 px-3 rounded-lg text-[13px] font-medium disabled:opacity-50 whitespace-nowrap ';
  const style = kind === 'primary' ? { color: '#ffffff' } : kind === 'danger' ? { color: '#b42318' } : undefined;
  const cls = kind === 'primary' ? 'bg-[var(--color-accent)]' : 'border border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-text)]';
  return <button type={rest.type ?? 'button'} title={rest.title} disabled={rest.disabled} onClick={rest.onClick} class={base + cls + ' ' + (rest.class ?? '')} style={style}>{children}</button>;
}

export function ErrorLine({ error }: { error: string | null | undefined }) {
  return error ? <div role="alert" class="text-[12.5px] text-[#b42318]">{error}</div> : null;
}

export const val = (e: Event) => (e.target as HTMLInputElement).value;

/** Slice 5 §02: one-click .xlsx of the test (SOP tabs). Names on by default
 *  (the teacher's own file); off swaps in test-local codes (§51). */
export function DownloadSpreadsheet({ a }: { a: string }) {
  const [names, setNames] = useState(true);
  return (
    <span class="inline-flex items-center gap-2" data-download-spreadsheet>
      <a href={`/api/t/assessments/${a}/export.xlsx?names=${names ? 1 : 0}`} download
        class="h-9 px-3 rounded-lg text-[13px] font-medium border border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-text)] grid place-items-center whitespace-nowrap">
        Download spreadsheet
      </a>
      <button type="button" aria-pressed={names} onClick={() => setNames(!names)} title="Off: student codes (S001...) instead of names"
        class="h-9 px-2 rounded-lg text-[12px] border border-[var(--color-border)] text-[var(--color-text-muted)] whitespace-nowrap">
        {names ? 'Names: on' : 'Names: off'}
      </button>
    </span>
  );
}
